import React, { useState } from 'react';
import { ChevronDown, ShoppingCart, Globe } from 'lucide-react';
import logo from './images/logo.jpg'

const MegaDropdowntest = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleMouseEnter = (dropdownName) => {
    setActiveDropdown(dropdownName);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const shopDropdownData = {
    men: {
      title: "INDUSTRIAL",
      items: [
        {name:"CONTINUOUS INKJET PRINTERS", href:"/LT"},
        {name:"THERMAL INKJET PRINTERS", href:"/TIJ"},
        {name:"THERMAL TRANSFER OVERPRINT", href:"/TTO"},
        {name:"LASER PRINTER", href:"/Laser"},
        {name:"WEIGHING SCALES", href:"/Industrial"},
        {name:"PACKAGING MACHINES", href:"#"},
       
      ]
    },
    women: {
      title: "RETAIL",
      items: [
        {name:"EAS SYSTEM", href:"/EAS System"},
        {name:"RETAIL WEIGHING SCALE", href:"/retail-weighing-scale"},
        {name:"BARCODE PRODUCTS", href:"/barcode-products"},
        {name:"ELECTRONIC SHELF LABEL", href:"/ESL"},
        {name:"MOBILE SECURITY", href:"/mobile-security-devices"},
        {name:"POS SYSTEMS", href:"/sunmi-devices"},
      ]
    },
    
    // accessories: {
    //   title: "ACCESSORIES",
    //   items: [
    //     "DETACHERS",
    //     "DEACTIVATOR",
    //     "TAGS AND LABELS"
    //   ]
    // }
  };

  const promoImages = [
    {
      title: "EAS",
      subtitle: "TAGS AND LABELS",
      bgColor: "bg-slate-800",
      textColor: "text-white"
    },
    {
      title: "INDUSTRIAL", 
      subtitle: "PRINTER CONSUMABLES",
      bgColor: "bg-slate-300",
      textColor: "text-slate-800"
    }
  ];

  return (
    <div className="w-full bg-white shadow-lg">
      {/* Main Navigation */}
      <nav className="fixed top-0 left-0 right-0  bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="text-2xl font-bold text-slate-800 tracking-wider">
            <img src={logo} style={{height:"30px", width:"100px"}}></img>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-slate-600 hover:text-slate-800 transition-colors">
              HOME
            </a>
            <a href="/services" className="text-slate-600 hover:text-slate-800 transition-colors">
              SERVICES
            </a>
            
            {/* Shop Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => handleMouseEnter('shop')}
              onMouseLeave={handleMouseLeave}
            >
            <div className='flex items-center'>
              <button className="flex items-center text-slate-600 hover:text-slate-800 transition-colors">
                PRODUCTS
                <ChevronDown className="w-4 h-4 ml-1" />
              </button>

              {/* Mega Dropdown */}
              {activeDropdown === 'shop' && (
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-screen max-w-5xl bg-white shadow-2xl border-t-2 border-emerald-400 z-50 mt-0 pt-2">
                  <div className="p-8">
                    <div className="grid grid-cols-12 gap-8">
                      {/* Category Columns */}
                      {Object.entries(shopDropdownData).map(([key, category]) => (
                        <div key={key} className="space-y-4 col-span-3">
                          <h3 className="font-bold text-slate-800 text-sm tracking-wider border-b border-slate-200 pb-2">
                            {category.title}
                          </h3>
                          <div className="space-y-3">
                            {category.items.map((item, index) => (
                              <a 
                                key={index}
                                href={item.href} 
                                className="block text-slate-600 hover:text-emerald-600 transition-colors text-sm"
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                        </div>
                      ))}

                      {/* Promotional Banners */}
                      <div className="col-span-4 space-y-5 mr-[10px]">
                        {promoImages.map((promo, index) => (
                          <div 
                            key={index}
                            className={`${promo.bgColor} ${promo.textColor} p-6 rounded-lg relative overflow-hidden cursor-pointer hover:scale-105 transition-transform`}
                          >
                            <div className="relative z-10">
                              <p className="text-xs font-medium mb-1 opacity-80">
                                {promo.title}
                              </p>
                              <h4 className="text-lg font-bold">
                                {promo.subtitle}
                              </h4>
                            </div>
                            {/* Decorative element */}
                            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-white/10 to-transparent rounded-full transform translate-x-6 -translate-y-6"></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            </div>

            <a href="/aboutus" className="text-slate-600 hover:text-slate-800 transition-colors">
              ABOUT
            </a>
            <a href="/contactus" className="text-slate-600 hover:text-slate-800 transition-colors">
              CONTACT
            </a>

            {/* Cart Icon */}
            {/* <div className="relative">
              <Globe className="w-6 h-6 text-slate-600 hover:text-slate-800 cursor-pointer transition-colors" />
              
              
              {/* <span className="absolute -top-2 -right-2 bg-emerald-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                2
              </span> */}
            {/* </div>
            <div className='relative'>
              <ChevronDown className="w-6 h-6 text-slate-600 hover:text-slate-800 cursor-pointer transition-colors" />
            </div> */} 

            <button
              type="button"
              className="flex items-center gap-1 text-slate-600 hover:text-slate-800 cursor-pointer transition-colors"
            >
              <Globe className="w-6 h-6" />
              <span className="text-sm font-medium">EN</span>  {/* Replace with dynamic lang code */}
              <ChevronDown className="w-4 h-4" />
            </button>

          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button className="text-slate-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
          </div>
        </div>
      </nav>

      {/* Demo Content */}
      {/* <div className="bg-emerald-50 py-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-slate-800 mb-4">
            Mega Dropdown Menu Demo
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Hover over the "SHOP" menu item to see the mega dropdown in action. 
            This component features multiple columns, promotional banners, and smooth animations.
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default MegaDropdowntest;